module.exports = __webpack_public_path__ + "img/client-croxton.d13947ce.png";